export default __webpack_public_path__ + "static/media/news (5).e03e5ff3.webp";